'use strict';

angular.module('amexReconciliationApp')
  .service('CurrencyService',
    function CurrencyService() {
      
      var self = this;
      
      self.switchCommasAndPeriods = function(inputString) {
        var outputString;
        if (inputString) {
          outputString = inputString.toString().trim();
          outputString = outputString.replace(/\./g,'PERIOD');
          outputString = outputString.replace(/,/g,'COMMA');
          outputString = outputString.replace(/PERIOD/g,',');
          outputString = outputString.replace(/COMMA/g,'.');
          return outputString;
        } else {
          return inputString;
        }
      };
     
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/CurrencyService.js
// module id = 635
// module chunks = 0